import { create } from 'zustand';

const useModeState = create((set) => ({
    mode: '',
    setmode: (newmode) => set(() => ({ mode: newmode })),
}));

export default useModeState;
